import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/reservation`;

export const getReservation = (statusInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-reservation-list`,
  body: statusInfo
});

export const getReservationByID  = (statusInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-reservation`,
  body: statusInfo
});

export const getReservationTypeList = () => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-reservation-campaign-list`
});

export const getReservationTimeList = (formData) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-reservation-period-list`,
  body: formData
});

export const updateReservation = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/update`,
  body: updateInfo
});

export const deleteApi = (formData) => callApi({
  method: 'POST',
  endpoint: `${basePath}/cancel-reservation`,
  body: formData
});

export const check = (checkInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/check`,
  body: checkInfo
});

export const success = (successInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/success`,
  body: successInfo
});

export const storeLorealReservation = (storeInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/add-reservation`,
  body: storeInfo
});

export const getReservationReport = (formData) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-reservation-report`,
  body: formData
});

export const getReservationDistrictReport = (formData) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-reservation-record-count`,
  body: formData
});

export const getByBaReport = (formData) => callApi({
  method: 'POST',
  endpoint: `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/report/get-binding-ba`,
  body: formData
});

export const getByCounterReport = (formData) => callApi({
  method: 'POST',
  endpoint: `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/report/get-binding-counter`,
  body: formData
});
